import React from 'react';
import { Modal } from 'react-bootstrap';
import { Node } from 'reducers/nodesReducer';
import NodeForm from './NodeForm';
import { Script } from 'reducers/scriptReducer';

type TEnableNodePopup = {
  nodes: string[];
  onClose: () => void;
  onSave: (_: Node) => void;
  pending: boolean;
  aetsAlreadyTaken: string[];
  onDicomEchoClick: (_: Node) => void;
  scripts: Script[];
};

export default function InsertNodePopup({
  nodes,
  onClose,
  onSave,
  pending,
  aetsAlreadyTaken,
  onDicomEchoClick,
  scripts
}: TEnableNodePopup): React.ReactElement {
  return (
    <Modal show size="lg">
      <Modal.Header>
        <Modal.Title>New node</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <NodeForm
          aetsAlreadyTaken={aetsAlreadyTaken}
          node={{ protocol: 'DICOM', enabled: true, forwardFavorite: false }}
          onClose={onClose}
          onSave={onSave}
          pending={pending}
          saveButtonLabels={['Add', 'Adding..']}
          nodes={nodes}
          onDicomEcho={onDicomEchoClick}
          scripts={scripts}
        />
      </Modal.Body>
    </Modal>
  );
}
